import { computed } from 'mobx';

export default class RatingEquationModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = item.id;
    this.name = item.name;
    this.station_id = item.station_id;
    this.start_time = item.start_time;
    this.end_time = item.end_time;
    this.status = item.status;
    this.remarks = item.remarks;
    this.equations = item.equations || [];
    this.stage = item.stage;
    this.discharge = item.discharge;
  }

  @computed get asJson() {
    return {
      id: this.id,
      name: this.name,
      station_id: this.station_id,
      start_time: this.start_time,
      end_time: this.end_time,
      status: this.status,
      remarks: this.remarks,
      equations: this.equations || [],
      stage: this.stage,
      discharge: this.discharge,
    };
  }

  updateFromJson(json) {
    this.id = json.id;
    this.name = json.name;
    this.station_id = json.station_id;
    this.start_time = json.start_time;
    this.end_time = json.end_time;
    this.status = json.status;
    this.remarks = json.remarks;
    this.equations = json.equations || [];
    this.stage = json.stage;
    this.discharge = json.discharge;
  }
}



// WEBPACK FOOTER //
// ./src/models/Hydrology/RatingEquationModel.js